import React from "react";
import PageShell from "../components/PageShell";

const updates = [
  {
    version: "Aktuell",
    title: "Mehr Kontrolle für Mitbringlisten",
    items: [
      "Lehrkräfte entscheiden, ob Namen in der Teilnehmeransicht angezeigt werden.",
      "Lehrkräfte entscheiden, ob Teilnehmerinnen und Teilnehmer eigene Listeneinträge ergänzen dürfen.",
      "Die Anzahl vorhandener Listeneinträge kann nachträglich in der Lehreransicht geändert werden.",
      "Für jede Liste kann ein Flyer mit QR-Code gedruckt werden."
    ]
  },
  {
    version: "Vorher",
    title: "Grundfunktionen",
    items: [
      "Listen mit Vorlagen erstellen.",
      "QR-Code und Teilnehmerlink teilen.",
      "Teilnehmerinnen und Teilnehmer tragen sich mit Anzahl ein.",
      "Lehrkräfte sehen die Liste live, können sie schließen, wieder öffnen, löschen und als PDF drucken."
    ]
  }
];

function ChangelogPage() {
  return (
    <PageShell maxWidth="max-w-3xl">
      <section className="rounded-2xl border border-[#dce8c8] bg-white p-6 shadow-sm sm:p-8">
        <p className="mb-3 text-xs font-medium uppercase tracking-[0.22em] text-neutral-500">Updates</p>
        <h1 className="text-3xl font-semibold tracking-[-0.04em]">Changelog</h1>

        <div className="mt-8 space-y-5">
          {updates.map(update => (
            <article className="rounded-xl border border-[#dce8c8] bg-[#f8faf2] p-5" key={update.title}>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#5f7f2f]">{update.version}</p>
              <h2 className="mt-2 text-xl font-semibold tracking-[-0.02em] text-neutral-950">{update.title}</h2>
              <ul className="mt-4 space-y-2 text-sm leading-6 text-neutral-700">
                {update.items.map(item => (
                  <li key={item}>• {item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>
    </PageShell>
  );
}

export default ChangelogPage;
